import { put, putResolve, select } from 'redux-saga/effects'
import decode from 'jwt-decode'

import { STORE_TOKENS, SET_SCOPE } from '@piconetworks/network-middleware'

import Zoid from 'common/modules/zoid'
import Internal from 'common/modules/internal'
import logger from 'common/logger'

import { creators } from '../actions'

export function* watchUpdateToken({ accessToken, refreshToken }) {
    const { scope: prevScope, ...rest } = yield select(Zoid.selectors.getXprops)

    let nextScope = null

    try {
        const decodedToken = decode(accessToken)
        nextScope = decodedToken.scope
    } catch (error) {
        // do nothing
    }

    if (prevScope === 'user' && nextScope === 'guest') {
        logger.error('token degradation error', {
            ...rest,
            scope: prevScope,
        })

        return
    }

    yield putResolve({
        type: STORE_TOKENS,
        access_token: accessToken,
        refresh_token: refreshToken,
    })

    // guest users never get refresh tokens
    // if you get a refresh token, you are by definition authenticated
    // we never store access tokens for users on local disk

    if (refreshToken) {
        yield put(creators.storeRefreshToken({ refreshToken }))
    }

    if (accessToken) {
        yield put(creators.storeAccessToken({ accessToken }))
    }

    yield putResolve({
        type: SET_SCOPE,
        scope: nextScope,
    })

    yield Internal.creators.sendMessage({
        payload: { target: '*', type: SET_SCOPE, scope: nextScope },
    })
}
export function* watchStoreRefreshToken({ refreshToken }) {
    const { sendHostMessage } = yield select(Zoid.selectors.getXprops)
    sendHostMessage('TOKEN/STORE/REFRESH', refreshToken)
}
export function* watchRemoveRefreshToken() {
    const { sendHostMessage } = yield select(Zoid.selectors.getXprops)
    sendHostMessage('TOKEN/REMOVE/REFRESH')
}
export function* watchStoreAccessToken({ accessToken }) {
    const { sendHostMessage } = yield select(Zoid.selectors.getXprops)
    sendHostMessage('TOKEN/STORE/ACCESS', accessToken)
}
export function* watchRemoveAccessToken() {
    const { sendHostMessage } = yield select(Zoid.selectors.getXprops)
    sendHostMessage('TOKEN/REMOVE/ACCESS')
}
